import { instance } from '@/libs/api/instance.js'

/**
 * Close wallet
 *
 * @param {string} id - wallet UUID
 * @return {Promise<axios.AxiosResponse<any>>}
 */
export const close = (id) => {
  return instance.delete(`/v3/wallet/${id}`)
}
